<template>
  <div>
    <span v-translate>Nastavení oprávnění</span>
    <table class="vypis" v-if="loaded">
      <thead>
      <tr>
        <th><span class="name" v-translate>Sekce</span></th>
        <th><span class="name" v-translate>Vytváření</span></th>
        <th><span class="name" v-translate>Čtení</span></th>
        <th><span class="name" v-translate>Úprava</span></th>
        <th><span class="name" v-translate>Mazání</span></th>
      </tr>
      </thead>
      <tbody>
      <role-groups-select-row
          v-for="(item, index) of roles"
          :key="'roles_'+index"
          :name="definitions[index]['name']"
          :id="index"
          :operations="definitions[index]['operations']"
          :value="item"
          :type="definitions[index]['type']"
          @input="onChange($event, index)"
          :is-editable="isSectionEditable(index)"
          :is-user="isUser"
      />
      </tbody>
    </table>
  </div>
</template>

<script>
import RoleGroupsSelectRow from "./RoleGroupsSelectRow";

export default {
  name: "RoleGroupsSelectList",
  components: {RoleGroupsSelectRow},
  created(RoleGroupsService) {
    this.roleGroupsService = RoleGroupsService;
    this.roleGroupsService.getListOptions()
        .then((data) => {
          if (this.roles === null) {
            this.roles = {};
          }
          this.definitions = data.definitions;
          this.initRoles();
          this.loaded = true;
        });
  },
  props: {
    value: Object,
    isUser: Boolean,
    userRole: String,
    editAllowedSections: {
      type: Array,
      default: () => {return [];}
    },
    isEditable: Boolean,
  },
  data() {
    return {
      loaded: false,
      definitions: null,
      roles: this.value,
    };
  },
  methods: {
    initRoles(){
      let actions = ['create', 'read', 'update', 'delete'];
      let value = this.isUser ? null : 'NONE';
      Object.keys(this.definitions).forEach(key => {
        let missing = [];
        if (!this.roles.hasOwnProperty(key)) {
          this.roles[key] = {};
          missing = actions;
        }else {
          missing = actions.filter(item => !(Object.keys(this.roles[key]).includes(item)));
        }
        for(const missingAction of missing){
          this.roles[key][missingAction] = value;
        }
      });
      this.roles = Object.keys(this.roles)
          .sort()
          .reduce((obj, key) => {
            obj[key] = this.roles[key];
            return obj;
          },{});
    },
    isSectionEditable(sectionName){
      return this.isEditable && this.editAllowedSections.includes(sectionName);
    },
    onChange(value, index) {
      this.roles[index] = value;
      this.$emit('input', this.roles);
    },
  },
  watch: {
    userRole(){
      this.roles= {};
      this.initRoles();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/roleGroups/forms/RoleGroupsSelectList.vue